import React, { useState } from 'react';
import { useSelector } from 'react-redux';

import {
    loadParticipantsAdvancedSearch,
    loadParticipantsSimpleSearch
} from '../../../store/participantService';
import { DEFAULT_TABLE_ROWS_PER_PAGE } from '../../../utils/formValidation/commonConstants';
import { PARTICIPANTS_ERROR } from '../../../utils/formValidation/loadingErrorMessageConstants';
import { stableSort } from '../../../utils/sortFunctions';
import ResultsTable from '../../table/ResultsTable';
import LoadingSpinner from '../../ui/LoadingSpinner';

import ParticipantTableRow from './ParticipantTableRow';

import app from '../../../app.module.css';
import search from './searchResults.module.css';

const headCells = [
    { id: 'ptCode', label: 'Participant ID' },
    { id: 'firstName', label: 'First Name' },
    { id: 'lastName', label: 'Last Name' },
    { id: 'postcode', label: 'Post Code' },
    { id: 'uniqueIdentifier', label: 'Unique ID' },
    { id: 'primaryPhoneNumber', label: 'Primary Phone Number' },
    { id: 'emailAddress', label: 'Email Address' }
];

const initialRowMetaData = {
    order: 'asc',
    orderBy: 'firstName',
    page: 0,
    rowsPerPage: DEFAULT_TABLE_ROWS_PER_PAGE
};

const TIMEOUT = import.meta.env.MODE === 'test' ? 2000 : 30 * 1000;

const ParticipantSearchResults = () => {
    // LOCAL STATE
    const [showSensitiveCells, setShowSensitiveCells] = useState(false);
    const [rowMetaData, setRowMetaData] = useState(initialRowMetaData);

    // STORE STATE
    const participantsSearch = useSelector(
        (state) => state.entities.participantService.participantsSearch
    );
    const loadingParticipantsSearch = useSelector(
        (state) => state.entities.participantService.loadingParticipantsSearch
    );
    const participantsSearchMetaData = useSelector(
        (state) => state.entities.participantService.participantsSearchMetaData
    );
    const { searchTerm, type: searchType } = useSelector(
        (state) => state.entities.participantService.participantSearchConfig
    );

    // HELPER FNS
    const createRows = () =>
        stableSort(participantsSearch, rowMetaData.orderBy, rowMetaData.order).map((el) => (
            <ParticipantTableRow key={el.ptCode} row={el} showSensitiveCells={showSensitiveCells} />
        ));

    // EVENT HANDLERS
    const onRevealSensitiveData = () => {
        setShowSensitiveCells(!showSensitiveCells);
        setTimeout(
            () => setShowSensitiveCells((showSensitiveCells) => !showSensitiveCells),
            TIMEOUT
        );
    };

    // RENDER
    return (
        <div className={app.pageContainer}>
            <h1 className={app.mainHeading}>Participant Search Results</h1>
            <div className={search.wrapper}>
                {participantsSearch.length < 1 ? (
                    <LoadingSpinner content={PARTICIPANTS_ERROR} />
                ) : (
                    <ResultsTable
                        defaultOrderBy={'firstName'}
                        defaultRowsPerPage={rowMetaData.rowsPerPage}
                        sortOrder={rowMetaData.order}
                        headCells={headCells}
                        loadResults={
                            searchType === 'advanced'
                                ? loadParticipantsAdvancedSearch
                                : loadParticipantsSimpleSearch
                        }
                        passRowMetaDataUp={setRowMetaData}
                        onRevealSensitiveData={onRevealSensitiveData}
                        tableRows={createRows()}
                        searchData={searchTerm}
                        apiParams={searchTerm}
                        showSensitiveCells={showSensitiveCells}
                        totalResults={participantsSearchMetaData.totalElements}
                        metaData={participantsSearchMetaData}
                        loadingValues={loadingParticipantsSearch}
                    />
                )}
            </div>
        </div>
    );
};

export default ParticipantSearchResults;
